import React from 'react';
import Link from 'gatsby-link';
import Markdown from 'react-markdown';
import Helmet from 'react-helmet';
import styled from '../utils/styled';
import { Typography, Grid } from '@material-ui/core';
import Section from '../components/Section';
import ContactForm from '../components/ContactForm';

const content = `
Seikluseksperdid OÜ  
Tihasheina tee 9  
74117 Maardu
Eesti

Registrikood: 14503058  
E-post: seikluseksperdid@gmail.com    
Telefon: +372 52 75 333
`;

const Contact = ({ data }) => {
  return (
    <Section>
      <Grid item xs={12} sm={8}>
        <Helmet title="Kontakt" />
        <Typography variant="display1">Kontakt</Typography>
        <Typography component={Markdown} source={content} escapeHtml={false} />
        <ContactForm/>
      </Grid>
    </Section>
  );
};
export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact.js